import React from 'react'

export default class ErrorBoundary extends React.Component {
  state = { 
    hasError: false 
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return (
        <h1 className="error">
          <div>
            <span>Oops! Something went wrong...</span>
            <span>Click <a href="https://plan.capitalmindwealth.com">here</a> to reload the page.</span> 
          </div>
        </h1>
      )
    }
    return this.props.children
  }
}




// WEBPACK FOOTER //
// ./src/components/common/ErrorBoundary.js